import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { TechReportListItemResponse } from './definitions/tech-report-list-response-item.interface';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';

@Injectable()
export class GetTechReportListService {
  private apiUrl: string = this.configService.config.rest.apiV2Url;

  constructor(
    private client: HttpClient,
    private configService: ConfigService
  ) {}

  public getReportsList(
    taskId: string,
  ): Observable<Array<TechReportListItemResponse>> {
    const url = `${this.apiUrl}/tasks/${taskId}/partial-damage-reports`;

    return this.client
      .get<Array<TechReportListItemResponse>>(url)
      .pipe(
        catchError((error) => throwError(() => handleProblem(error)))
      );
  }
}
